import simg from '../images/service/hydro1.jpg'
import simg2 from '../images/service/ac2.jpg'
import simg3 from '../images/service/hl2.jpg'
import simg4 from '../images/service/ql2.jpg'
import simg5 from '../images/service/d1.jpg'
import simg6 from '../images/service/d2.jpg'

import sIcon1 from '../images/icon/hydro1.jpg'
import sIcon2 from '../images/icon/ac2.jpg'
import sIcon3 from '../images/icon/hl2.jpg'
import sIcon4 from '../images/icon/ql2.jpg'
import sIcon5 from '../images/icon/d1.jpg'
import sIcon6 from '../images/icon/d2.jpg'

import sSingleimg1 from '../images/service-single/2.jpg'
import sSingleimg2 from '../images/service-single/3.jpg'



const Services = [
    {
        Id: '1',
        sImg:simg,
        sIcon:sIcon1,
        sTitle: 'Hydrochloric Acid',
        description:'High-purity industrial grade hydrochloric acid for various chemical processes and applications.',
        ssImg1:sSingleimg1,
        ssImg2:sSingleimg2,
        link: '/hydrochloric-acid'
    },
    {
        Id: '2',
        sImg:simg2,
        sIcon:sIcon2,
        sTitle: 'Activated Carbon',
        description:'Premium quality activated carbon for water purification, air filtration, and industrial applications.',
        ssImg1:sSingleimg1,
        ssImg2:sSingleimg2,
        link: '/activated-carbon'
    },
    {
        Id: '3',
        sImg:simg3,
        sIcon:sIcon3,
        sTitle: 'Hydrated Lime',
        description:'Superior grade hydrated lime for water treatment, construction, and chemical manufacturing processes.',
        ssImg1:sSingleimg1,
        ssImg2:sSingleimg2,
        link: '/hydrated-lime'
    },
    {
        Id: '4',
        sImg:simg4,
        sIcon:sIcon4,
        sTitle: 'Quick Lime',
        description:'High-quality quick lime for steel production, construction, and environmental applications.',
        ssImg1:sSingleimg1,
        ssImg2:sSingleimg2,
        link: '/quick-lime'
    },
    {
        Id: '5',
        sImg:simg5,
        sIcon:sIcon5,
        sTitle: 'Dolomite',
        description:'Pure dolomite mineral for agriculture, construction, and industrial manufacturing applications.',
        ssImg1:sSingleimg1,
        ssImg2:sSingleimg2,
        link: '/dolomite'
    },
    {
        Id: '6',
        sImg:simg6,
        sIcon:sIcon6,
        sTitle: 'Di Methyl Sulphate',
        description:'Industrial grade dimethyl sulphate for chemical synthesis and pharmaceutical manufacturing.',
        ssImg1:sSingleimg1,
        ssImg2:sSingleimg2,
        link: '/dimethyl-sulphate'
    }
]
export default Services;